import React, { useState } from "react";
import { useFirebase } from "../../database/FirebaseContext";
import EditSprint from "./EditSprint";

function SprintItem({
    sprint,
    openDetail,
    openSprintBacklog,
    chooseSelectedItems,
    openChart,
    colourBlindMode
}) {
    const { deleteSprint } = useFirebase();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const getSprintDate = (date) => {
        return `${date.toDate().getDate()}/${
            date.toDate().getMonth() + 1
        }/${date.toDate().getFullYear()}`;
    };

    const getStatusBackgroundColor = (colourBlindMode, status) => {
        if (colourBlindMode === true) {
            switch (status) {
                case "Active":
                    return "bg-[#94B71D]";
                case "Completed":
                    return "bg-[#A3C7FF]";
                default:
                    return "bg-[#AB9B9F]";
            }
        }
        else {
            switch (status) {
                case "Active":
                    return "bg-[#11D000]";
                case "Completed":
                    return "bg-[#7DD0FF]";
                default:
                    return "bg-[#A49E9E]";
            }
        }
      };

    return (
        // sprint container
        <div className="relative bg-[#616675] w-[95%] h-auto flex-1 py-2 rounded-3xl mt-[30px]">
            {/* section container */}
            <div
                className="text-white justify-between text-3xl relative flex mt-3 mb-2 mx-[6%] px-[2vh]"
                onClick={() => openChart(sprint)}
            >
                <span>{sprint.sprintName}</span>
                {/* sprint icon */}
                <div class="whitespace-nowrap text-2xl">
                    <i
                        class="fa-solid fa-ellipsis"
                        onClick={() => {
                            openSprintBacklog();
                            chooseSelectedItems(sprint);
                        }}
                    ></i>
                    <i
                        className="fa-solid fa-pen-to-square fa-lg list-item-icon ml-4 text-white"
                        onClick={() => openModal()}
                    ></i>
                    <i
                        className="fa-solid fa-trash-can fa-lg list-item-icon ml-3 text-white"
                        onClick={() => deleteSprint(sprint.id)}
                    ></i>
                </div>
            </div>

            <div className="flex flex-col" onClick={() => openDetail(sprint)}>
                <div
                    className={`${getStatusBackgroundColor(colourBlindMode,
                        sprint.sprintStatus
                    )} h-[3vh] w-[85%] ml-[3vh] mt-[1vh] lg:mb-4 rounded-full flex items-center justify-center text-center text-xl text-white`}
                >
                    {sprint.sprintStatus}
                </div>
                <div className="bg-[#3D3E44] h-[3vh] w-[85%] mx-[3vh] lg:mb-4 rounded-full flex items-center justify-center text-center text-xl text-white">
                    Starting from {getSprintDate(sprint.sprintStartDate)}
                </div>
                <div className="bg-[#3D3E44] h-[3vh] w-[85%] mx-[3vh] mb-4 rounded-full flex items-center justify-center text-center text-xl text-white">
                    Ending on {getSprintDate(sprint.sprintEndDate)}
                </div>
            </div>
            {isModalOpen && (
                <EditSprint sprint={sprint} closeModal={closeModal} />
            )}
        </div>
    );
}

export default SprintItem;
